import { ErrorToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const HandleCancelCallService = async (body) => {
  const cancelRes = await AxiosPostMethod(
    "org/automation/call/cancel-service",
    body
  );
  if (cancelRes.status === 200) {
    return true;
  } else if (cancelRes.status === 403) {
    ErrorToast("Service already started, so we can't cancel now!");
    return null;
  } else if (cancelRes.status === 409) {
    ErrorToast("Service has already been executed and cannot be deleted");
    return null;
  } else {
    if (cancelRes.status === 401) HandleLogout();

    ErrorToast("Can't delete service, Please try again later");
    return null;
  }
};

export default HandleCancelCallService;